export default __webpack_public_path__ + "static/media/office.60b04e2d.svg";